// English texts of the pages redone in C2 (French is the inline fallback of each t() call)
const en = {
    navigation: {
        merge: "Merge",
        zones: "Zone settings",
        auctions: "Auctions",
        recovery: "Recovery",
        pl: "PL service",
        personnages: "Characters"
    },
    dashboard: {
        mergeManagement: "Merge rankings across servers",
        zonesManagement: "Zones offered for reservations",
        auctionsManagement: "Free zones up for auction",
        recoveryManagement: "Messages missed by the bot, to review",
        plManagement: "Beneficiaries and wisdom set loans",
        personnagesManagement: "Members' characters and requests to review"
    },
    channelConfig: {
        title: "Channel configurations",
        subtitle: "Manage several channel configurations for different sections of the server"
    },
    bareme: {
        baremesPlural: "point scales",
        baremeSingular: "point scale"
    },
    events: {
        unknownType: "Unknown type"
    },
    server: {
        loadError: "❌ Error while loading data",
        channelsPlural: "channels",
        channelSingular: "channel",
        rolesPlural: "roles",
        roleSingular: "role",
        hideHelp: "Hide help",
        showHelp: "Help",
        siteAdminRole: "Discord Administrator role (informational only)",
        botMonitoring: "Automatic bot monitoring",
        botMonitoringTitle: "Automatic monitoring",
        botMonitoringDesc: "The Discord bot automatically watches the channels configured below to detect fight screenshots (attacks and defenses) and save them in the system.",
        monitoredChannels: "Monitored channels",
        noMonitoring: "No channel configured - the bot is not monitoring any channel",
        types: "types"
    },
    seasons: {
        loadingError: "Error while loading the season",
        noSeasonsMessage: "Start by creating your first season to organize your competitions."
    },
    alliance: {
        season: "Season",
        noSeason: "No season in progress",
        noSeasonHint: "The next season will be announced by the admins.",
        currentSeason: "Current season",
        seasonProgress: "Season progress",
        lastDay: "Last day",
        daysLeft: "{n} days left",
        reservationSheet: "Reservation sheet",
        swapPhase: "Swap phase",
        inProgress: "In progress",
        finished: "Closed",
        viewSheet: "View the sheet",
        noSheet: "No sheet in progress",
        noSheetHint: "The sheet has not been published yet.",
        auctions: "Auctions",
        auctionsOpen: "Auctions open",
        auctionsClosed: "Auctions closed",
        until: "Until {date}",
        opensAtEndOf: "Opens at the end of season",
        opensAtEndOfCurrent: "Opens at the end of the current season.",
        topBid: "Top bid",
        topZonePrev: "Top zone (prev. season)",
        joinAuctions: "Join the auctions",
        myPepites: "My pépites",
        owedToYou: "Owed to you",
        lastDistribution: "Last distribution on {date}",
        received: "{n} received",
        paidNextDistribution: "Paid at the next distribution",
        myZones: "My zones this season",
        noZoneOnSheet: "No zone is assigned to you on the current sheet.",
        noZoneYet: "No zone reserved yet.",
        checkPreferences: "Check my preferences",
        sourceAuction: "Auction",
        sheetFrozen: "Sheet frozen",
        provisional: "Provisional",
        myAuctions: "My auctions",
        noBidYet: "You haven't bid on any zone yet.",
        noLastAuction: "You didn't take part in the last auction.",
        leading: "Leading",
        outbid: "Outbid",
        zonesWon: "{n} zones won",
        zoneWon: "{n} zone won",
        yourBid: "Your bid: {n}",
        bestBidVsYours: "Best bid: {n} · yours: {mine}",
        won: "Won",
        topBidChip: "Top bid",
        lost: "Lost",
        noZoneWon: "No zone won.",
        rebid: "Bid again",
        viewAuctions: "View the auctions",
        loadError: "Unable to load the information.",
        theAlliance: "The alliance",
        me: "Me"
    },
    member: {
        nav: {
            general: "General information",
            stats: "My stats",
            preferences: "My preferences",
            sheet: "Reservation sheet",
            auctions: "Auctions",
            personnages: "My characters"
        }
    },
    adminHome: {
        memberArea: "Member area",
        resaCard: "Reservation sheet",
        openSheet: "Open the sheet",
        reservations: "Reservations",
        disabled: "Disabled",
        noActiveSheet: "No active sheet.",
        activeSheet: "Active sheet",
        memberSwaps: "Swaps between members",
        open: "Open",
        closed: "Closed",
        assignments: "Assignments",
        automatic: "Automatic",
        frozen: "Frozen",
        openAuctions: "Open the auctions",
        status: "Status",
        noAuction: "No open auction",
        auctionOpen: "Open",
        auctionToClose: "Ended, to close",
        end: "End",
        endedOn: "Ended on",
        bidsTotal: "Total bids",
        zonesWithBid: "Zones with a bid",
        bidsN: "{n} bids",
        bidN: "{n} bid",
        rightNow: "Right now"
    },
    memberStats: {
        attacks: "Attacks",
        defenses: "Defenses",
        atkDefTitle: "Attacks / defenses",
        fightsAllSeasons: "{n} fights across all seasons",
        fightAllSeasons: "{n} fight across all seasons",
        range24h: "24 h",
        range7d: "7 days",
        range30d: "30 days",
        activityTitle: "Activity hours",
        activitySubtitle: "Fights per hour · Paris time",
        period: "Period",
        noActivity: "No activity over this period",
        fightType: "Fight type",
        season: "Season",
        atkPts: "Atk pts",
        defPts: "Def pts",
        rank: "Rank",
        total: "Total",
        attacks5v5: "5v5 attacks",
        defenses5v5: "5v5 defenses",
        in4v5: "{n} in 4v5",
        totalPoints: "Total points",
        allSeasons: "all seasons",
        bestRank: "Best rank",
        avgPerSeason: "Average / season",
        seasonsPlayed: "{n} seasons played",
        seasonPlayed: "{n} season played",
        bestScore: "Best score",
        inOneSeason: "in a single season",
        loading: "Loading statistics...",
        loadError: "Unable to load your statistics.",
        emptyHint: "Your statistics will show up at the end of your first season.",
        splitActivity: "Split and activity",
        perSeason: "Season details"
    },
    prefs: {
        saved: "Preferences saved",
        saveError: "Error while saving preferences",
        loading: "Loading your preferences...",
        title: "My zone preferences",
        zonesToRank: "{n} zones to rank",
        saving: "Saving...",
        save: "Save",
        unsaved: "Unsaved changes",
        savedOn: "Preferences saved on {date} at {time}",
        notSavedYet: "You haven't saved any preferences yet: the server's default order is used.",
        ranking: "Ranking",
        searchPlaceholder: "Search a zone or a dungeon...",
        searchLabel: "Search a zone",
        resultsHint: "{n} results · clear the search to drag rows",
        resultHint: "{n} result · clear the search to drag rows",
        dragHint: "Drag the rows, use the arrows or click a rank to type it. #1 = your favorite zone.",
        noMatch: "No zone matches “{q}”",
        rank: "Rank",
        move: "Move",
        zone: "Zone",
        dungeon: "Dungeon",
        newRankFor: "New rank for {zone}",
        clickToEditRank: "Click to type a rank",
        dragToMove: "Drag to move",
        moveUp: "Move {zone} up",
        moveDown: "Move {zone} down"
    },
    sheet: {
        confirmSwap: "Swap “{from}” for “{to}”?",
        noZone: "no zone",
        swapDone: "Your zone is now “{zone}”",
        swapError: "The swap could not be done",
        loading: "Loading the sheet...",
        loadError: "Unable to load the current sheet.",
        noSheet: "No reservation sheet in progress at the moment.",
        myZones: "My zones",
        swapOpen: "Swap phase in progress",
        swapClosed: "Swap phase over",
        frozen: "Sheet frozen",
        notRegistered: "You are not registered on this sheet.",
        noZoneYet: "No zone yet",
        cancel: "Cancel",
        changeZone: "Change zone",
        auction: "Auction",
        pickFreeZone: "Pick a free zone to replace",
        yourSpot: "your spot",
        freeCountPlural: "{n} free",
        freeCount: "{n} free",
        searchZone: "Search a zone...",
        searchFreeZone: "Search a free zone",
        allTaken: "All zones are taken.",
        freeZones: "Free zones",
        freeAfterAuction: "An auction is running on this sheet: free zones will be shown once the auction is closed.",
        freeMayChange: "Swaps are open: this list may still change.",
        noFreeMatch: "No free zone matches.",
        allReservations: "All reservations",
        reservationsCount: "{n} reservations",
        reservationCount: "{n} reservation",
        searchTablePlaceholder: "Player or zone...",
        searchTable: "Search the sheet",
        player: "Player",
        zone: "Zone",
        dungeon: "Dungeon",
        me: "me",
        auctionChip: "auction"
    },
    auctionMember: {
        filterAll: "All",
        filterMine: "My bids",
        filterFree: "No bid",
        favorite: "Add to favorites",
        unfavorite: "Remove from favorites",
        favoriteError: "The favorite could not be saved",
        confirmBid: "Bid {amount} on “{zone}”?\n\nA bid cannot be withdrawn.",
        won: "Won",
        leading: "Leading",
        outbid: "Outbid",
        bids: "{n} bids",
        bid: "{n} bid",
        startsAt: "Starts at {amount}",
        wonBy: "Won by {name}",
        endedNoBid: "Ended without a bid",
        bidAmount: "Bid {amount}",
        otherAmount: "Other amount (min. {min})",
        otherAmountOn: "Other amount on {zone}",
        placeBid: "Bid",
        bidExtended: "Bid saved on “{zone}” · anti-snipe: the zone is extended",
        nowLeading: "You are leading on “{zone}”",
        bidError: "The bid could not be saved",
        loadError: "Unable to load the auctions.",
        subtitle: "Zones left free after the swap phase",
        noneRunning: "No auction in progress",
        noneRunningHint: "Auctions open at the end of the season, after the swap phase of the reservation sheet.",
        lastAuction: "Last auction",
        youWon: "You won:",
        noneSold: "No zone sold.",
        endsIn: "ends in {time}",
        ruleStart: "Starts at {amount}",
        ruleIncrement: "Minimum raise of {amount}",
        ruleSnipe: "Anti-snipe: a bid in the last {n} minutes adds {n} min",
        ruleNoWithdraw: "No withdrawal after a bid",
        leadingOnZones: "Leading on {n} zones",
        leadingOnZone: "Leading on {n} zone",
        outbidOnZones: "Outbid on {n} zones",
        outbidOnZone: "Outbid on {n} zone",
        zonesUp: "{n} zones up for auction",
        filterZones: "Filter zones",
        searchZone: "Search a zone...",
        searchZoneLabel: "Search a zone",
        noMatch: "No zone matches."
    },
    pepitesAdmin: {
        loadError: "Error while loading pépites",
        channelSaved: "Pépites channel configured!",
        saveError: "Error while saving",
        confirmDelete: "Delete this entry? This cannot be undone.",
        entryDeleted: "Entry deleted",
        deleteError: "Error while deleting",
        invalidAmount: "Invalid amount",
        entryUpdated: "Entry updated",
        updateError: "Error while updating",
        nothingToDistribute: "No pépites to distribute at the moment",
        copied: "{n} copied",
        unpaidWarning: "{n} player(s) are not ticked as paid.",
        confirmFinish: "Finish the distribution? Counters will be reset and an archive will be kept.",
        finished: "Distribution finished, counters reset",
        archiveError: "Error while archiving pépites",
        subtitle: "Alliance pépites management",
        payTitle: "Shows the amounts to give in game, then archives and resets the counters",
        pay: "Pay & redistribute",
        recycled: "Recycled pépites",
        toRedistribute: "To redistribute ({rate})",
        players: "Players",
        entries: "Entries",
        channelTitle: "Pépites channel",
        currentChannel: "Current channel:",
        channelDesc: "When a player posts a message containing a number and a screenshot in this channel, the bot automatically records their pépites.",
        discordChannel: "Discord channel",
        selectChannel: "-- Select a channel --",
        saving: "Saving...",
        perPlayer: "Summary per player",
        searchPlayer: "Search a player...",
        searchPlayerLabel: "Search a player",
        noPlayerMatch: "No player matches the search",
        noneYet: "No pépites recorded yet",
        configureFirst: "Configure a Discord channel above first.",
        player: "Player",
        totalPepites: "Total pépites",
        toGive: "To give ({rate})",
        lastEntry: "Last entry",
        hide: "Hide",
        details: "Details",
        date: "Date",
        amount: "Amount",
        note: "Note",
        noEntry: "No entry",
        newAmount: "New amount",
        validate: "Confirm",
        editAmount: "Edit the amount",
        deleteEntry: "Delete the entry",
        history: "Distribution history",
        noHistory: "No archived distribution yet.",
        distributionOf: "Distribution of {date}",
        by: "By {name}",
        recycledLower: "pépites recycled",
        paidOut: "paid out ({rate} %)",
        playersRewarded: "players rewarded",
        entriesCounted: "entries counted",
        topPlayers: "Top players:",
        payMode: "Payment mode",
        payIntro: "Give each player the amount shown in game ({rate} of their recycled pépites), then tick them. Ticks are only used to track the payment.",
        toGiveInGame: "To give in game ({rate})",
        paid: "Paid",
        recycledCount: "{n} recycled",
        copyAmount: "Copy the amount",
        later: "Later",
        archiving: "Archiving...",
        finishReset: "Finish and reset"
    },
    zonesAdmin: {
        copyDiscard: "Your unsaved changes will be replaced. Continue?",
        copyEmpty: "This server has no zones",
        copyDone: "List copied from {server}: check it, then save",
        copyError: "Unable to load this server's zones",
        copyTitle: "Copy from another server",
        copyDesc: "Takes the list and order of zones from another server. This server's BDA zones stay BDA (and are kept even if the other server doesn't have them). Nothing is saved until you click “Save”.",
        copySource: "Source server",
        copyPick: "— Choose a server —",
        copyBtn: "Copy the list",
        loadError: "Error while loading zones",
        alreadyExists: "The zone “{zone}” already exists",
        confirmRemoved: "{n} deleted zone(s) will also be removed from members' preferences.\n\nSave the list?",
        prefsUpdated: "{n} preference list(s) updated",
        saved: "Zones saved",
        saveError: "Error while saving",
        confirmReset: "Go back to the default zone list?\n\nThis server's custom list will be erased.",
        resetDone: "Default list restored",
        resetError: "Error while resetting",
        subtitle: "Zones offered to members for reservations",
        saving: "Saving...",
        save: "Save",
        zones: "Zones",
        bdaZones: "BDA zones (private)",
        custom: "Custom",
        default: "Default",
        modifiedOn: "List modified on {date}",
        serverList: "Server list",
        addTitle: "Add a zone",
        addDesc: "New zones are added at the end of the list and at the end of the ranking for members who have already filled in their preferences.",
        zone: "Zone",
        zonePlaceholder: "E.g.: NILEZA",
        dungeonOptional: "Dungeon (optional)",
        dungeonPlaceholder: "E.g.: Winter Garden",
        listTitle: "Zone list",
        filterZones: "Filter zones",
        viewAll: "All",
        viewOpen: "Open",
        searchPlaceholder: "Search a zone or a dungeon...",
        searchLabel: "Search a zone",
        listDesc: "A BDA zone is kept private by the server: it disappears from members' preferences and is no longer assigned in reservation sheets (except frozen sheets). The order is the default ranking for members who haven't filled in their preferences. Renaming a zone updates members' preferences; sheets already saved keep the old name.",
        unsaved: "Unsaved changes",
        removedCount: "{n} zone(s) deleted",
        duplicates: "Duplicate names",
        unnamed: "Zone without a name",
        noMatch: "No zone matches the search",
        noZone: "No zone",
        dungeon: "Dungeon",
        zoneName: "Zone name",
        formerly: "formerly “{name}”",
        reopen: "Reopen the zone to members",
        privatize: "Make the zone private (BDA)",
        open: "Open",
        moveUp: "Move up",
        moveDown: "Move down",
        deleteZone: "Delete {zone}",
        defaultList: "Default list",
        defaultListDesc: "Erases this server's custom list and goes back to the zone list provided with the site.",
        restoreDefault: "Restore the default list"
    },
    tempoAdmin: {
        loadError: "Error while loading the tempo configuration",
        pickChannel: "Choose the tempo channel",
        tierIncomplete: "Each tier needs a minimum and a number of points",
        saved: "Tempo configuration saved",
        activated: "New tempo system enabled",
        saveError: "Error while saving",
        loading: "Loading the tempo configuration...",
        subtitle: "Points awarded according to fight duration",
        saving: "Saving...",
        save: "Save",
        activate: "Enable the new system",
        activeChannel: "New system active · channel #{channel}",
        unsaved: "Unsaved changes",
        switchTitle: "Switching to the new system",
        switchDesc: "A single channel: members post their screenshot with the duration, and points depend on the tier.",
        switchLegacy: "Screenshots already counted with the old system (one channel per tier) keep their points in every season.",
        channelTitle: "Tempo channel",
        discordChannel: "Discord channel",
        selectChannel: "-- Select a channel --",
        tiersTitle: "Points by duration",
        addTier: "Add a tier",
        tiersDesc: "Bounds included. Leave the maximum empty for “and more”.",
        from: "From",
        to: "to",
        tierMin: "Tier {n}: minimum in minutes",
        tierMax: "Tier {n}: maximum in minutes",
        tierPoints: "Tier {n}: points",
        deleteTier: "Delete tier {n}",
        simulation: "Simulation",
        fightDuration: "Fight duration (minutes)",
        points: "points",
        forMembers: "For members",
        howTo: "In the tempo channel, post the screenshot with the duration and mention the players. Each mentioned player gets the points.",
        example: "@Player1 @Player2 1h30",
        formats: "Accepted formats: 45 · 45 min · 1h · 1h30. The bot reacts ⏱️ when it's counted, ❓ if it can't find the duration.",
        legacyTitle: "Old points per channel (kept for old screenshots)",
        channel: "Channel",
        tier: "Tier",
        pointsCol: "Points"
    },
    resaList: {
        loadError: "❌ Unable to load the sheets",
        enabledToast: "✅ Reservation enabled for members",
        disabledToast: "Reservation disabled for members",
        toggleError: "❌ Unable to change the setting",
        created: "✅ Sheet created!",
        createError: "❌ Error while creating",
        renamed: "✅ Sheet renamed",
        renameError: "❌ Error while renaming",
        confirmDelete: "Delete “{title}”? This cannot be undone.",
        deleted: "🗑️ Sheet deleted",
        deleteError: "❌ Error while deleting",
        copySuffix: "(copy)",
        copyName: "Name of the copy:",
        copyNameEmpty: "❌ The name of the copy cannot be empty",
        copied: "✅ Sheet copied ({n} row(s))",
        copyError: "❌ Error while copying the sheet",
        statusLive: "Live",
        statusSwap: "Swaps open",
        statusFrozen: "Frozen",
        statusClosed: "Closed",
        subtitle: "Create and manage your reservation sheets",
        newSheet: "New sheet",
        featureOn: "Reservation enabled for members",
        featureOff: "Reservation disabled for members",
        featureOnDesc: "Members see the “My preferences”, “Reservation sheet” and “Auctions” tabs in their area.",
        featureOffDesc: "Reservation tabs are hidden in the member area. You can still prepare your sheets here.",
        toggleLabel: "Enable reservation for members",
        sheetsCount: "{n} sheets",
        sheetCount: "{n} sheet",
        liveCount: "{n} live",
        swapsOpen: "{n} swaps open",
        swapOpen: "{n} swap open",
        sheetName: "Sheet name",
        sheetNamePlaceholder: "E.g.: Sheet S7 — Week 1",
        creating: "Creating...",
        create: "Create",
        sheets: "Sheets",
        searchPlaceholder: "Search a sheet...",
        searchLabel: "Search a sheet",
        noSheet: "No sheet created",
        noMatch: "No sheet matches your search.",
        createFirst: "Create the first sheet",
        sheet: "Sheet",
        status: "Status",
        createdOn: "Created on",
        newName: "New sheet name",
        rename: "Rename",
        renameItem: "Rename {title}",
        open: "Open",
        copySheet: "Copy the sheet",
        copyItem: "Copy {title}",
        deleteSheet: "Delete the sheet",
        deleteItem: "Delete {title}"
    },
    auctionAdmin: {
        recapTitle: "Summary by member",
        recapLine: "• {name} — {n} zone(s) ({zones}) → {total}",
        recapCopied: "Summary copied",
        recapCopyError: "Unable to copy the summary",
        recapProvisional: "Provisional",
        copy: "Copy",
        member: "Member",
        confirmDelete: "Permanently delete “{title}” from the history?\n\nIts zones, bids and payments will be erased and no longer count in the statistics.",
        deleted: "Auction deleted",
        deleteError: "Unable to delete the auction",
        deleteAuction: "Delete {title}",
        deleteTitle: "Delete from history",
        confirmLaunch: "Launch the auction on the free zones of “{title}” until {date}?",
        theSheet: "the sheet",
        launched: "Auction launched",
        launchError: "Unable to launch the auction",
        launchTitle: "Launch an auction",
        launchDesc: "All zones left free on the sheet (except BDA zones) are put up for auction. Winners get their zone until the end of the season.",
        sheet: "Reservation sheet",
        pickSheet: "— Choose a sheet —",
        frozenSuffix: "(frozen)",
        endsAt: "Auction end",
        oneDay: "1 day",
        twoDays: "2 days",
        startingBid: "Starting bid (kamas)",
        minIncrement: "Minimum raise (kamas)",
        antiSnipe: "Anti-snipe (minutes)",
        channel: "Discord auction channel",
        pickChannel: "— Choose a channel —",
        channelHint: "The bot announces the opening there, tags the outbid player on each raise and posts the results.",
        launching: "Launching...",
        launch: "Launch the auction",
        confirmCloseNow: "Close now? Zones still open end immediately, the current best bids win.",
        confirmClose: "Close the auction and announce the results?",
        closed: "Auction closed",
        closeError: "Unable to close",
        running: "In progress",
        toClose: "Ended · to close",
        zones: "Zones",
        zonesWithBid: "Zones with a bid",
        bids: "Bids",
        bidsTotal: "Total bids",
        meta: "Planned end {date} · start {start} · +{inc} minimum · anti-snipe {n} min",
        follow: "Follow the auction",
        closing: "Closing...",
        close: "Close",
        subtitle: "Free zones put up for auction after the swap phase",
        paymentsToTrack: "Payments to track",
        unpaidZones: "{n} unpaid zone(s)",
        statistics: "Statistics",
        auctions: "Auctions",
        zonesSold: "Zones sold",
        avgPrice: "Average price",
        totalSold: "Total sold",
        leftToPay: "Left to pay",
        topZones: "Most expensive zones",
        topBuyers: "Biggest buyers",
        zonesN: "{n} zones",
        zoneN: "{n} zone",
        history: "History",
        noHistory: "No finished auction yet.",
        auction: "Auction",
        closedOn: "Closed on",
        total: "Total",
        paid: "Paid",
        detail: "Details",
        filterAll: "All",
        filterBids: "With a bid",
        filterNone: "No bid",
        filterUnpaid: "Unpaid",
        paidError: "Unable to update the payment",
        confirmRemoveBid: "Remove {name}'s bid ({amount})? The best remaining bid becomes the leading bid again.",
        bidRemoved: "Bid removed",
        removeBidError: "Unable to remove the bid",
        confirmCloseDetail: "Close now? Zones still open end immediately and the results are announced.",
        notFound: "Auction not found.",
        backToAuctions: "Back to auctions",
        closedOnDate: "Closed on {date}",
        endsIn: "Ends in {time}",
        allEnded: "All zones have ended",
        paidSingular: "Paid",
        filterZones: "Filter zones",
        searchPlaceholder: "Zone or player...",
        zone: "Zone",
        bestBid: "Best bid",
        player: "Player",
        end: "End",
        won: "Won",
        unsold: "Unsold",
        paidFor: "Paid: {zone}",
        removed: "Removed",
        removeBidTitle: "Remove this bid (fake bid)",
        removeBid: "Remove this bid",
        actions: "Actions",
        zoneName: "Zone name",
        dungeonOptional: "Dungeon (optional)",
        dungeon: "Dungeon",
        save: "Save",
        cancel: "Cancel",
        lotSaved: "Zone updated",
        lotSaveError: "Could not update the zone",
        confirmDeleteLotBids: "Remove the zone “{zone}” from the auction? Its {n} bid(s) will also be deleted.",
        confirmDeleteLot: "Remove the zone “{zone}” from the auction?",
        lotDeleted: "Zone removed from the auction",
        lotDeleteError: "Could not remove the zone",
        editLot: "Edit the zone",
        editLotFor: "Edit: {zone}",
        deleteLot: "Remove the zone from the auction",
        deleteLotFor: "Remove: {zone}",
        noZone: "No zone"
    },
    createSeasonModal: {
        botOffline: "The Discord bot is not connected, try again in a moment.",
        loadError: "Unable to load the server's channels and point scales.",
        required: "Required field",
        endAfterStart: "The end date must be after the start date",
        created: "Season “{title}” created",
        createError: "Error while creating the season",
        title: "New season",
        progress: "Required fields filled",
        loading: "Loading channels and point scales...",
        season: "Season",
        name: "Season name",
        namePlaceholder: "E.g.: Season 12 — Autumn",
        publicationChannel: "Publication channel",
        pickChannel: "— Choose a channel —",
        startDate: "Start date",
        endDate: "End date",
        baremesChannels: "Point scales and channels",
        attackBareme: "Attack scale",
        noAttackBareme: "No attack scale: create one in Point scales.",
        pickBareme: "— Choose a scale —",
        defenseBareme: "Defense scale",
        noDefenseBareme: "No defense scale: create one in Point scales.",
        channelConfig: "Channel configuration",
        channelConfigHint: "Attack and defense channels counted for this season",
        defaultConfig: "Server default configuration",
        defaultSuffix: "(default)",
        descOptions: "Description and options",
        description: "Description",
        descPlaceholder: "Goals, rewards, special rules...",
        autoPublish: "Automatically publish the ranking at the end of the season",
        includeTempo: "Include tempo points",
        creating: "Creating...",
        create: "Create the season"
    },
    editSeason: {
        notFound: "Season not found",
        configSaved: "Configuration saved",
        configSaveError: "Error while saving the configuration",
        adjustFailures: "{n} adjustment(s) could not be saved",
        rankingSaved: "Ranking saved",
        rankingSaveError: "Error while saving the ranking",
        noPlayer: "No player in the ranking",
        namesUpdated: "{n} names updated",
        namesPartial: "{n}/{total} names retrieved, try again if needed",
        nothingToExport: "No ranking to export",
        csvRank: "Rank",
        csvPlayer: "Player",
        csvAttack: "Attack pts",
        csvDefense: "Defense pts",
        csvTempo: "Tempo pts",
        csvBase: "Base points",
        csvAdjust: "Adjustment",
        csvTotal: "Total",
        saveRankingFirst: "Save the ranking changes first",
        published: "Ranking published on Discord",
        publishError: "Publishing failed: {error}",
        loading: "Loading the season...",
        mergeTitle: "Merge this ranking with other seasons",
        merge: "Merge",
        publish: "Publish",
        status: {
            archived: "Archived",
            upcoming: "Upcoming",
            ended: "Ended",
            running: "In progress"
        },
        rankedPlayers: "{n} ranked players",
        rankedPlayer: "{n} ranked player",
        configuration: "Configuration",
        none: "— None —",
        saving: "Saving...",
        saveRecalc: "Save and recalculate",
        ranking: "Ranking",
        searchPlayer: "Search a player...",
        searchPlayerLabel: "Search a player",
        namesTitle: "Fetch names from Discord again",
        namesLoading: "Names...",
        names: "Names",
        exportTitle: "Export as CSV (Excel)",
        export: "Export CSV",
        unsavedAdjusts: "{n} unsaved adjustments",
        unsavedAdjust: "{n} unsaved adjustment",
        save: "Save",
        computing: "Computing the ranking...",
        noPlayerMatch: "No player matches the search",
        noFight: "No fight recorded for this season",
        player: "Player",
        attack: "Attack",
        defense: "Defense",
        tempo: "Tempo",
        points: "Points",
        adjustment: "Adjustment",
        total: "Total",
        adjustFor: "Points adjustment for {name}",
        publishTitle: "Publish the ranking",
        publishDesc: "The ranking of {n} players will be posted in the chosen channel.",
        noChannel: "No channel available: check that the bot can see the server's channels.",
        searchChannel: "Search a channel...",
        searchChannelLabel: "Search a channel",
        seasonChannel: "season channel",
        publishing: "Publishing..."
    },
    adminSite: {
        filterAdmins: "Administrators",
        filterAll: "Everyone",
        roles: {
            owner: "Owner",
            siteAdmin: "Site Administrator",
            serverAdmin: "Server Administrator",
            member: "Member"
        },
        perms: {
            configuration: "Configuration",
            bareme: "Point scales",
            tempo: "Tempo",
            saisons: "Seasons",
            fusion: "Merge",
            zones: "Zones",
            reservation: "Reservations",
            statistiques: "Statistics",
            pepites: "Pépites",
            encheres: "Auctions",
            evenements: "Events",
            rattrapage: "Recovery",
            pl: "PL service",
            personnages: "Characters"
        },
        rightsSaved: "{name}'s rights saved",
        rightsSaveError: "Error while saving the rights",
        rightsOf: "{name}'s rights",
        rightsIntro: "Tick the pages available on each server. A server with no page doesn't show up in their admin area.",
        searchServer: "Search a server...",
        searchServerLabel: "Search a server",
        none: "None",
        all: "All",
        noServerMatch: "No server matches.",
        saving: "Saving...",
        save: "Save",
        loadError: "Unable to load the administrators",
        confirmPromote: "Make {name} a Site Administrator?\n\nThis person will have every right on every server and will be able to manage Server Administrators.",
        confirmDemote: "Remove the Site Administrator role from {name}?",
        promoted: "{name} is now a Site Administrator",
        demoted: "{name} is no longer a Site Administrator",
        roleError: "Error while changing the role",
        title: "Site administration",
        subtitleOwner: "Owner · administrators management",
        subtitleAdmin: "Site Administrator · Server Administrators management",
        serversWithBot: "Servers with the bot",
        usersLogged: "Logged-in users",
        siteAdmins: "Site admins",
        serverAdmins: "Server admins",
        admins: "Administrators",
        searchPlaceholder: "Username or Discord ID...",
        searchLabel: "Search a person",
        howTo: "To give someone rights, they must have logged in to the site at least once: look for them in “Everyone”.",
        ownerOnly: "Only the owner can appoint Site Administrators.",
        noMatch: "Nobody matches the search",
        noAdmin: "No administrator yet",
        fullAccess: "Every right on every server",
        noAccess: "No admin access",
        allRights: "all",
        rightsN: "{n} rights",
        rightN: "{n} right",
        serverRights: "Server rights",
        siteAdmin: "Site admin",
        siteAdminFor: "Site Administrator: {name}"
    },
    botCommands: {
        title: "Bot commands",
        hint: "To type in Discord, on the server where the bot is.",
        nullos: {
            description: "Lists the Discord server members who took part in no fight (attack, defense or tempo) during the chosen season, so at 0 points.",
            access: "Special role set in Configuration"
        },
        mp: {
            description: "Sends the message privately to every member who has the chosen role.",
            access: "Discord Administrator"
        },
        potionsRecolte: {
            description: "Records a harvest, with the key used (Vortex, Solar or none).",
            access: "“Gestionnaire BDA” role"
        },
        potionsPose: {
            description: "Records a placement: adds a potion to the player's counter.",
            access: "“Gestionnaire BDA” role"
        },
        potionsRecap: {
            description: "Shows the potions and keys used by everyone.",
            access: "“Gestionnaire BDA” role"
        },
        potionsClear: {
            description: "Resets a member's potions and keys.",
            access: "“Gestionnaire BDA” role"
        }
    },
    maintenance: {
        badge: "Site under construction",
        text: "A new version of the site is coming soon. The Discord bot keeps working normally.",
        denied: "Your account doesn't have access to the site during the works.",
        login: "Log in with Discord",
        hint: "Access restricted to the team during the works."
    },
    baremePage: {
        deleteItem: "Delete {name}",
        alliesEnemies: "Allies / enemies",
        fixedTitle: "Fixed points “against all”",
        optional: "(optional)",
        fixedDefense: "Fixed defense points against all",
        fixedAttack: "Fixed attack points against all",
        example25: "E.g.: 25"
    },
    seasonsPage: {
        visibleInStats: "✅ Season visible in member stats",
        hiddenFromStats: "🚫 Season hidden from member stats",
        visibilityError: "❌ Unable to change the visibility"
    },
    mergePage: {
        showLess: "Show less",
        showMore: "Show the {n} other seasons",
        nothingToRestore: "No generated ranking to restore.",
        localReset: "✅ Local changes undone.",
        channelsError: "Unable to load the list of Discord channels.",
        pickChannel: "Select a publication channel.",
        published: "✅ Merged ranking published!",
        publishError: "Error while publishing.",
        csvLocal: "Local change",
        csvParticipations: "Participations",
        exported: "📥 Ranking exported!",
        partnerError: "Error while loading the partner server's seasons.",
        min2Total: "Select at least 2 seasons in total.",
        min2: "Select at least 2 seasons.",
        crossError: "Error during the cross-server merge.",
        mergeError: "Error while merging the rankings.",
        title: "Merge rankings",
        subtitle: "Combine several seasons, from one or more servers, into a single ranking",
        toMerge: "Seasons to merge",
        selectedN: "{n} seasons selected",
        selected1: "{n} season selected",
        uncheckAll: "Uncheck all",
        merging: "Merging...",
        regenerate: "Regenerate the ranking",
        generate: "Generate the ranking",
        servers: "Servers",
        removeServer: "Remove this server",
        addServer: "Add this server's seasons",
        searchSeason: "Search a season...",
        searchSeasonLabel: "Search a season",
        showArchived: "Show archived seasons ({n})",
        thisServer: "This server",
        noSeason: "No season available.",
        noSeasonServer: "No season available on this server.",
        noResult: "No ranking generated",
        noResultHint: "Tick at least 2 seasons on the left, then click “Generate the ranking”.",
        merged: "Merged ranking",
        resultMeta: "{players} players · {seasons} seasons",
        undo: "Undo changes",
        export: "Export (.csv)",
        stale: "The selection has changed since the ranking was generated.",
        regenerateShort: "Regenerate",
        partShort: "Part.",
        adjustTitle: "Add/remove points locally",
        adjustFor: "Adjustment: {name}",
        removePlayer: "Remove this player from the merged ranking",
        removeName: "Remove {name}",
        publishTitle: "Publish the merged ranking",
        customTitle: "Custom title (optional)",
        customTitlePlaceholder: "E.g.: VSA Dakal × Mikhal ranking — May 2026",
        channelsN: "{n} channels",
        loadingChannels: "Loading channels...",
        noChannel: "No channel available. Check that the bot is on this server.",
        noChannelMatch: "No matching channel.",
        loadFusionError: "Unable to load this merge.",
        deleteFusionConfirm: "Delete the merge “{title}”? Reservation sheets using it will no longer have a ranking.",
        fusionDeleted: "🗑️ Merge deleted.",
        deleteFusionError: "Error while deleting.",
        fusionPrefix: "Merge",
        and: "and",
        fusionTitleRequired: "Give the merge a name.",
        fusionSaved: "✅ Merge saved: it is now available in reservation sheets.",
        saveFusionError: "Error while saving the merge.",
        savedFusions: "Saved merges",
        loadFusion: "Load this merge",
        nSeasons: "{n} seasons",
        deleteFusion: "Delete the merge {title}",
        deleteFusionShort: "Delete",
        saveFusion: "Save the merge",
        fusionName: "Merge name",
        fusionNamePlaceholder: "E.g.: Merge - Season 15 and 16",
        saveFusionHint: "The merge will appear as a season in reservation sheets. Its ranking follows the source seasons; your adjustments and removed players are kept.",
        saveAsNew: "Save as new",
        updateFusion: "Update"
    },
    channelPage: {
        vsEnemy: "Against {n} enemy",
        vsEnemies: "Against {n} enemies",
        selectChannel: "Select a channel",
        migrated: "Existing configuration migrated automatically!",
        loadError: "Error while loading data",
        nameRequired: "The configuration name is required",
        created: "Configuration created!",
        updated: "Configuration updated!",
        nameTaken: "A configuration with this name already exists",
        saveError: "Error while saving",
        confirmDelete: "Delete the configuration “{name}”?",
        deleted: "Configuration “{name}” deleted",
        deleteError: "Error while deleting",
        defaultSet: "Configuration set as default",
        updateError: "Error while updating",
        loading: "Loading configurations...",
        newConfig: "New configuration",
        configsN: "{n} configurations",
        config1: "{n} configuration",
        channelsAvailable: "{n} channels available",
        channelAvailable: "{n} channel available",
        none: "No configuration created",
        noneHint: "Create your first configuration to get started",
        default: "Default",
        setDefault: "Set as default",
        duplicate: "Duplicate",
        configuredN: "{n} channels configured",
        configured1: "{n} channel configured",
        modifiedOn: "Modified on {date}",
        editConfig: "Edit the configuration",
        closeForm: "Close the form",
        name: "Configuration name *",
        namePlaceholder: "E.g.: PvP section, GvG section...",
        description: "Description",
        descriptionPlaceholder: "Optional description...",
        specialRole: "Special role",
        noSpecialRole: "No special role",
        isDefault: "Default configuration",
        attack: "Attack",
        defense: "Defense",
        typesN: "{n} types",
        generic: "Generic channels",
        genericDesc: "If you only have 1 or 2 channels for all attacks and defenses, use these fields as a fallback.",
        anyAttack: "Attack — for all attacks",
        anyAttackHint: "Used when no specific channel (Attack against N) is configured",
        anyDefense: "Defense — for all defenses",
        anyDefenseHint: "Used when no specific channel (Defense against N) is configured"
    },
    resaEdit: {
        bulkAdd: "Add",
        bulkCount: "Number of rows to add",
        bulkRowsWith: "rows with",
        bulkSeason: "Season of the new rows",
        bulkNoSeason: "— no season —",
        bulkAddBtn: "Add rows",
        groupSeasons: "Seasons",
        groupFusions: "Merges",
        configLoadError: "❌ Unable to load the configuration",
        loadError: "❌ Unable to load the reservations",
        pickSheetFirst: "❌ Select or create a sheet first",
        saved: "✅ Sheet saved!",
        saveError: "❌ Error while saving",
        liveSet: "📌 Sheet set as the live sheet!",
        liveUnset: "📌 Live sheet removed",
        updateError: "❌ Error while updating",
        thisSheet: "this sheet",
        published: "✅ Sheet published in the Discord channel!",
        publishError: "❌ Error while publishing",
        frozenToast: "🔒 Sheet frozen — zones will no longer be recalculated automatically",
        unfrozenToast: "🔓 Sheet unfrozen — auto-assignment is back on",
        statusError: "❌ Error while changing the status",
        swapOpened: "🔄 Swap window open — members can change zones!",
        swapClosed: "🔒 Swap window closed",
        changeError: "❌ Error while changing",
        prefsSaved: "✅ Preferences saved for {name}",
        prefsSaveError: "❌ Error while saving the preferences",
        editPrefs: "Edit the player's zone preferences",
        pickZoneManually: "Choose the zone manually",
        manualZone: "Manually chosen zone",
        backToAuto: "Back to automatic assignment",
        auto: "Auto",
        zoneFrozen: "Zone frozen",
        defaultOrder: "Default order (no preferences)",
        conflict: "Conflict",
        conflictHint: "All their preferences are taken",
        set: "Set",
        noPrefs: "No preferences",
        noPrefsHint: "The player hasn't filled in their preferences",
        back: "Reservation sheets",
        subtitle: "{players} player(s) · {zones} zone(s) assigned",
        auctionTitle: "Put the zones left free on this sheet up for auction",
        saveSheet: "Save the sheet",
        isLive: "Live sheet",
        setLive: "Set as live",
        isLiveHint: "Visible to members",
        setLiveHint: "Make it visible to members",
        isFrozen: "Sheet frozen",
        freeze: "Freeze the sheet",
        isFrozenHint: "Zones no longer move",
        freezeHint: "Lock the assigned zones",
        swapsOpen: "Swaps open",
        openSwaps: "Open swaps",
        swapsOpenHint: "Members can change zones",
        openSwapsHint: "Let members change zones",
        dragHint: "Drag the rows to change the priority order",
        dragToReorder: "Drag to reorder",
        publishTitle: "Publish in a channel",
        publishDesc: "Sends the sheet as saved to a Discord channel.",
        destination: "Target channel",
        selectChannel: "— Select a channel —",
        deleteDesc: "Permanently deletes the sheet and all its reservations.",
        prefsOf: "{name}'s preferences",
        prefsDesc: "Zones by priority order, saved for this player.",
        prefN: "Preference {n}",
        pickZone: "— Choose a zone —",
        removePrefN: "Remove preference {n}"
    },
    recovery: {
        openImage: "Open the screenshot",
        screenAlt: "Message screenshot",
        noImage: "Screenshot unavailable",
        pepitesAmount: "{n} pépites",
        tempoMinutes: "{m} min → {p} pts",
        tempoLegacy: "Tempo (old system, points by channel)",
        allEnemies: "all",
        combat: "{allies} allies against {enemies} enemies",
        select: "Select",
        kinds: {
            attaque: "Attack",
            defense: "Defense",
            tempo: "Tempo",
            pepite: "Pépites"
        },
        by: "by {name}",
        duplicate: "Looks like a submission already counted on {date}",
        see: "see",
        openDiscord: "View on Discord",
        reject: "Reject",
        accept: "Accept",
        restore: "Back to review",
        acceptedOn: "Accepted on {date}",
        rejectedOn: "Rejected on {date}",
        loadError: "Unable to load the messages to review",
        scanError: "Unable to start the search",
        confirmDuplicates: "{n} message(s) look like submissions already counted (probable duplicates). Accept them anyway?",
        confirmAccept: "Accept {n} messages? They will be counted as if they had been recorded on the day they were posted.",
        confirmReject: "Reject {n} messages?",
        accepted: "{n} message(s) accepted and counted",
        rejected: "{n} message(s) rejected",
        failed: "{n} message(s) could not be processed",
        decideError: "Error while saving the decision",
        restoreError: "Unable to put this message back to review",
        subtitle: "Screenshots and pépites posted while the bot couldn't see them: nothing counts until approved",
        scanTitle: "Search for missed messages",
        scanDesc: "The bot rereads every configured channel (attack, defense, tempo, pépites) over the chosen period and lists here the messages it didn't record. It also does it on its own at every restart.",
        from: "From",
        to: "To",
        scanning: "Searching...",
        scan: "Start the search",
        maxRange: "{n} days maximum.",
        scanRunning: "Searching from {from} to {to}...",
        scanFailed: "The search failed: {error}",
        scanDone: "{channels} channels reread, {scanned} messages read, {found} new to review",
        scanChannelErrors: "{n} channel(s) unreachable",
        lastAuto: "Last automatic recovery (bot restart): {date}",
        statusLabel: "Status",
        status: {
            review: "To review",
            accepted: "Accepted",
            rejected: "Rejected"
        },
        kindLabel: "Type",
        allKinds: "All",
        selectAll: "Select all ({n})",
        rejectSelected: "Reject selection ({n})",
        acceptSelected: "Accept selection ({n})",
        emptyReview: "Nothing to review: the bot didn't miss anything.",
        empty: "No message."
    },
    pl: {
        lendNow: "Lend a kit right away",
        lendAfterCreateError: "Record created, but the loan failed: {error}",
        lendIntro: "The full kit ({n} items) is lent. The screenshot is the proof.",
        lendKit: "Lend the kit",
        noFreeKit: "No full kit available.",
        noKits: "No kit. Add a kit: it comes prefilled with the wisdom set.",
        addItem: "Add an item",
        addKit: "Add a kit",
        aid: "{amount} aid",
        aidShort: "Aid",
        atHolder: "held by {name}",
        available: "Available",
        clientDeleted: "Record deleted",
        clients: "Beneficiaries",
        clientSaved: "Record saved",
        confirmCloseWithItems: "{name} still holds {n} item(s). Mark them as missing?",
        confirmDeleteClient: "Delete {name}'s record and its history?",
        confirmDeleteKit: "Delete “{name}”?",
        confirmNoScreen: "No screenshot attached. Continue anyway?",
        create: "Create",
        deleteClient: "Delete record",
        deleteError: "Unable to delete",
        deleteKit: "Delete kit",
        edit: "Edit",
        editKit: "Edit kit",
        filterAll: "All",
        filterOver: "Finished",
        heldItems: "Items held",
        history: "History",
        item: "Item",
        items: "Items",
        kit: "Kit",
        kitAllHere: "{n} items, all stored",
        kitCreated: "Kit created with the default wisdom set",
        kitName: "Kit name",
        kits: "Wisdom sets",
        kitSaved: "Kit saved",
        kpiActive: "PL in progress",
        kpiAid: "Aid granted",
        kpiCollected: "Collected",
        kpiLent: "Items lent",
        kpiLentMissing: "Items out, {n} missing",
        kpiUnpaid: "Left to collect",
        lend: "Lend",
        lendScreen: "Loan screenshot",
        lendTo: "Lend to {name}",
        lent: "Loan saved",
        lentCount: "{n}/{total} lent",
        lentShort: "Lent",
        levelN: "lvl {n}",
        loadError: "Unable to load the PL service.",
        loan: "Loan",
        loanScreens: "Screenshots taken at loan time",
        missing: "Missing",
        missingCount: "{n} item(s) missing",
        missingN: "{n} missing",
        newClient: "New PL",
        noClients: "No beneficiary.",
        noHistory: "No loan yet.",
        note: "Note",
        notes: "Notes",
        nothingHeld: "This player holds no item.",
        open: "Open",
        paid: "Price paid",
        paidShort: "Paid",
        player: "Player",
        price: "Price (kamas)",
        priceShort: "Price",
        removeItem: "Remove item",
        removeScreen: "Remove screenshot",
        return: "Return",
        returned: "Return saved",
        returnFrom: "Return from {name}",
        returnIntro: "Untick what was not returned: those items stay assigned to the player.",
        returnN: "Confirm return of {n} item(s)",
        returnScreen: "Return screenshot",
        returnShort: "Return",
        saveError: "Unable to save",
        saving: "Saving...",
        screenError: "Unable to read this image",
        screenHint: "Paste the screenshot (Ctrl+V), drop it here or click to choose it",
        since: "since {date}",
        slot: "Slot",
        startedOn: "Start",
        startLevel: "Starting level",
        status: "Status",
        statusActive: "In progress",
        statusCancelled: "Dropped",
        statusDone: "Finished",
        subtitle: "Track beneficiaries and lent wisdom sets",
        unpaidShort: "To pay"
    },
    personnages: {
        typeAdd: "Addition",
        typeEdit: "Change",
        typeRemove: "Removal",
        typeMigrate: "Migration",
        statusApproved: "Approved",
        statusRejected: "Rejected",
        statusPending: "Pending",
        migrationRoute: "{from} → {to}",
        requestSent: "Request sent: an admin has to approve it",
        sendError: "Could not send the request",
        declare: "Declare a character",
        editTitle: "Edit {name}",
        name: "Character name",
        nameHint: "Exactly as in game: the bot reads this name on screenshots.",
        classe: "Class",
        sendRequest: "Send request",
        migrateSent: "Request sent: an admin of the destination server has to approve it",
        migrateTitle: "Migrate {name}",
        noOtherServer: "You are not a member of any other server where the bot is present.",
        migrateIntro: "Once an admin of the destination server approves the request, the character is listed there and is no longer linked to your account here.",
        targetServer: "Destination server",
        confirmRemove: "Ask to no longer be linked to {name}?",
        cancelError: "Could not cancel",
        mineTitle: "My characters",
        mineSubtitle: "The characters you play: the bot uses them to give you the points of your screenshots. Every change is approved by an admin.",
        loadError: "Could not load the characters.",
        linked: "Characters linked to my account",
        noneYet: "No character yet. Declare the ones you play on this server.",
        sharedHint: "Another player also has access to this character",
        shared: "Shared",
        pendingType: "{type} pending",
        edit: "Edit",
        migrate: "Migrate to another server",
        remove: "Stop being linked",
        myRequests: "My requests",
        noRequests: "No request.",
        reasonLabel: "Reason: {reason}",
        cancelRequest: "Cancel",
        unknownPlayer: "Player {id}",
        rejectPrompt: "Reason for rejection (optional, shown to the player):",
        approved: "Request approved",
        rejected: "Request rejected",
        decideError: "Action failed",
        confirmUnlink: "Remove {name} from {player}'s characters?",
        unlinked: "Link removed",
        adminSubtitle: "Every player's characters and the review of their requests",
        kpiPending: "Pending requests",
        kpiPlayers: "Listed players",
        kpiPersonnages: "Characters",
        kpiShared: "Shared characters",
        pendingTitle: "Requests to review",
        noPending: "No pending request.",
        alreadyPlayedBy: "Already listed for {players}: the character will become shared",
        reject: "Reject",
        approve: "Approve",
        census: "Census",
        searchPlaceholder: "Player or character...",
        allClasses: "All classes",
        noPlayers: "No character listed yet.",
        noMatch: "No result.",
        player: "Player",
        characters: "Characters",
        sharedWith: "Shared with {players}",
        unlink: "Remove link",
        history: "Latest decisions",
        hide: "Hide",
        show: "Show ({n})",
        noHistory: "No decision yet.",
        reviewedBy: "by {admin}",
        siteSearchPlaceholder: "Username, Discord ID or character...",
        serverFilter: "Server",
        allServers: "All servers",
        siteSummary: "{players} Discord accounts · {personnages} characters listed on {servers} server(s).",
        sitePending: "Pending requests:",
        assignTitle: "Assign a character",
        addFor: "Add a character to {player}",
        assign: "Assign",
        assigned: "{name} assigned",
        assignedBy: "assigned directly by {admin}",
        editedBy: "edited directly by {admin}",
        editSharedHint: "This character is shared: the change applies to all its players.",
        save: "Save",
        saved: "{name} updated",
        changePlayer: "Change",
        memberSearch: "Username or Discord ID...",
        noMember: "No player found: paste their Discord ID.",
        useTypedId: "The character will be assigned to account {id}.",
        memberHint: "Players already seen by the bot on this server. Otherwise, paste the Discord ID (right-click the username → Copy User ID)."
    },
    classes: {
        feca: "Feca",
        osamodas: "Osamodas",
        enutrof: "Enutrof",
        sram: "Sram",
        xelor: "Xelor",
        ecaflip: "Ecaflip",
        eniripsa: "Eniripsa",
        iop: "Iop",
        cra: "Cra",
        sadida: "Sadida",
        sacrieur: "Sacrier",
        pandawa: "Pandawa",
        roublard: "Rogue",
        zobal: "Masqueraider",
        steamer: "Foggernaut",
        eliotrope: "Eliotrope",
        huppermage: "Huppermage",
        ouginak: "Ouginak",
        forgelance: "Forgelance"
    }
};

export default en;
